export default "/images/st1.jpg?ed057f72317ea5c79a3d41309de3c039";